import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Validation } from '../../helper';
import { UserActions } from '../../actions';
import { Input, Submit} from '../Form';
import { BoxTitle } from '../PageTemplate';


class ProfileForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            name: "",
            phone: "",
            logo: "",
            error: {
                email: false,
                password: false,
                name: false,
                phone: false
            },
            inputChanges: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /**
     * set state value as props value when they updated
     * @param {Object} props 
     */
    static getDerivedStateFromProps(props, state) {
        var userData = props.user.data;
        if(!userData) return null;

        const {email, name, phone, logo} = userData;
        if(email === state.email && name === state.name && phone === state.phone && logo === state.logo) return null;

        return {
            email: email || "",
            name: name || "",
            phone: phone || "",
            logo: logo || {}
        }
    }

    handleChange(event) {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);

        const userData = this.props.user.data;
        if(!userData) return;

        // check if has input chage 
        if( this.state.name !== userData.name 
            || this.state.password.length > 0
            || this.state.email !== userData.email 
            || this.state.phone !== userData.phone) {

            this.setState({inputChanges: true});
        } else {
            this.setState({inputChanges: false});            
        }
    }

    validation() {
        var err = {
            name: !Validation.fullName(this.state.name),
            email: !Validation.email(this.state.email),
            password: this.state.password.length > 0 && !Validation.password(this.state.password),
            phone: this.state.phone.length > 0 && !Validation.phone(this.state.phone)
        }

        this.setState({error: err});
        return !err.name && !err.email && !err.password && !err.phone; 
    }

    handleSubmit(event) {
        event.preventDefault();

        if(this.validation() && this.state.inputChanges) {
            const {dispatch} = this.props;
            var data = {
                email: this.state.email,
                name: this.state.name,
            }

            // password its optional (send password empty will cause error)
            if(this.state.password.length > 0) data.password = this.state.password;
            if(this.state.phone.length > 0) data.phone = this.state.phone;            

            dispatch(UserActions.updateUser(data));
            this.setState({inputChanges: false}); 
        }
    }

    render() {        
        const requestInProcess = this.props.user.updateDataProcess === true;

        return (
            <div id="profileForm">
                <BoxTitle icon="faUserCircle">
                    הפרטים שלי
                </BoxTitle>
                <div>
                    <form onSubmit={this.handleSubmit} noValidate>
                        <Input
                            name="name"
                            value={this.state.name}
                            placeholder="שם משתמש"
                            error={this.state.error.name}
                            errorText="שם משתמש לא תקין"
                            onChange={this.handleChange}
                        />
                        <Input
                            name="phone"
                            value={this.state.phone}
                            placeholder="טלפון"
                            error={this.state.error.phone}
                            errorText="טלפון לא תקין"
                            onChange={this.handleChange}
                        />
                        <Input
                            name="email"
                            value={this.state.email}
                            placeholder="אימייל"
                            error={this.state.error.email}
                            errorText="אימייל לא תקין"
                            onChange={this.handleChange}
                        />
                        <div className={`inputWrapper ${this.state.error.password ? 'inputError': ''}`}>
                            <input className="wraped" name="password" type="password" value={this.state.password} onChange={this.handleChange}/>
                            <div className="inputPlaceholder">
                                {this.state.error.password ? 'סיסמא לא תקינה' : 'שינוי סיסמא (לפחות 8 תווים)'}
                            </div>
                        </div>
                        <Submit process={requestInProcess} icon="faSave" text="עדכון פרטים"/>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer
    }
}

const ProfileFormWithRedux = connect(mapStateToProps)(ProfileForm);

export {ProfileFormWithRedux as ProfileForm};


// WEBPACK FOOTER //
// ./src/components/ProfilePage/ProfileForm.jsx